import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  MenuItem,
  DropdownButton,
  Modal,
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn, BootBootstrapButton, SearchField } from 'react-bootstrap-table';
import NoteFormRich from './NoteFormRich';


const styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲',
    },
  },
  classNames: {
    Row: 'row-class',
    Table: 'table-striped table',
    Filter: 'pull-right form-control',
  },
  styles: {
    Filter: { fontSize: 18 },
  },
};

class AcceptBidPopUp extends React.Component {
	constructor(props) {
      super(props);
      super(props);
      this.state = {
      		bids: false,
      		noteModel:false,
      		NotebidId: null,
          showConfirm:false,
       };
       this.saveBid = this.saveBid.bind(this);
       this.DeclineAllBids = this.DeclineAllBids.bind(this);
       this.openNote = this.openNote.bind(this);
       this.closeNote = this.closeNote.bind(this);
       this.saveNote = this.saveNote.bind(this);
       this.openConfirm = this.openConfirm.bind(this);
       this.closeConfirm = this.closeConfirm.bind(this);
    };
    componentDidMount() {
    	this.setState({ bids:this.props.bids});
    }

    saveBid(row,val){
    	let id = row;
    	let state = val
    	const payload = {};
    	payload.buyer_state = state;
    	if (!this.props.isTourManager) {
      		payload.buyer = { id: this.props.user.id };
    	}
    	this.props.editBid(id,payload)
    };
    saveNote(values) {
    this.props.editBid(this.state.NotebidId, { note_json: values });
    this.closeNote();
  }

    DeclineAllBids(e){
    	const state = e.currentTarget.getAttribute('data-item');
    	const payload = {};
    	let ids =[];

    	const bid  = this.props.bid;
    	let location;
      	if (bid.hotel.city == null){
        	location = `${bid.hotel.state}, ${bid.hotel.country}`;
      	};
      	if (bid.hotel.state == null){
        	location = `${bid.hotel.city}, ${bid.hotel.country}`;
      	};
      	if (bid.hotel.city == null && bid.hotel.state == null){
        	location = `${bid.hotel.country}`;
      	};
      	if (bid.hotel.city == null && bid.hotel.state == null && bid.hotel.country == null){
        	location = '';
      	};
      	if (bid.hotel.city != null && bid.hotel.state != null && bid.hotel.country != null){
        	if (bid.hotel.city === bid.hotel.state){
          		location = `${bid.hotel.city}, ${bid.hotel.country}`;
        	} else{
          		if (bid.hotel.state === bid.hotel.country){
            		location = `${bid.hotel.city}, ${bid.hotel.country}`;
          		}else{
            		location = `${bid.hotel.city}, ${bid.hotel.state}, ${bid.hotel.country}`;
          		}
         	}
      	};

    	this.props.bids.forEach(bid => {
    		if(!(bid.id==this.props.bid.id)){
    			if(bid.eventId === this.props.bid.bidset.event.id){
    				ids.push(bid.id)
    			}
    		}
    	})
    	ids.forEach(id =>{
    		payload.buyer_state = state;
    		if (!this.props.isTourManager) {
               payload.buyer = { id: this.props.user.id };
            }
            this.props.editBid(id, payload);
    	})
      this.closeConfirm();

    }
    openNote(id){
    	this.setState({ 
    		noteModel:true,
    		NotebidId:id,
    	});
    }
    closeNote(){
    	this.setState({ noteModel:false});
    }

    openConfirm(){
      this.setState({showConfirm:true}); 
    }
    closeConfirm(){
      this.setState({showConfirm:false});
    }

    trStyle = (row, rowIndex) => {
      return { backgroundColor: typeof(row) != 'undefined' ? row.bgcolor : ''};
  	};

    formatHotelDisplay = (row, rowIndex) => {  
    return (
    	<span title={row}> {row} </span>
    	)
 	};

 	formatStatusDisplay = (row, rowIndex) => {
    	if(row == 'Stay Cancelled') {
    		return (
      			<span className="stay-cancelled-text">{row}</span>
      		)
    	} else if(row == 'Stay Updated') {
    		return (
      			<span onClick={this.showUpdatePopup} className="stay-updated-text" title="Click here to see list of bids for Updated stay">{row}</span>
      		)
    	} else {
      		return (
      			<span>{row}</span>
      		)
    	}
  	};

  	btncolumn = (row,rowIndex) =>{
  		const DE = "DE";
  		const AC = "AC"; 
  		return(
  		    <div>
  		    {rowIndex.state=="Responded"?(
  		    <ButtonGroup>
        		<Button bsStyle="success" data-item={row} onClick={()=>this.saveBid(row,AC)}>
          		   <i className="fa fa-save fa-lg" /> Accept
        		</Button>
        	  </ButtonGroup>
  		    ):(
      		  <ButtonGroup>
        		<Button bsStyle="success" data-item={row} disabled>
          		   <i className="fa fa-save fa-lg" /> Accept
        		</Button>
        	  </ButtonGroup>)}&nbsp;&nbsp;
        	  <ButtonGroup>
        		<Button bsStyle="danger" data-item={row} onClick={()=>this.saveBid(row,DE)}>
          		   <i className="fa fa-times fa-lg" /> Decline
        	    </Button>
              </ButtonGroup>&nbsp;&nbsp;
              <ButtonGroup>
        		<Button bsStyle="success" onClick={()=>this.openNote(row)}>
            			<i className="fa fa-pencil" />
        	    </Button>
              </ButtonGroup>
           </div>
      )
 }
    render(){
    	const options = {
      		sortIndicator: false ,
      		defaultSortName: 'start',
    	};
    	const bid  = this.props.bid;
    	let location;
      	if (bid.hotel.city == null){
        	location = `${bid.hotel.state}, ${bid.hotel.country}`;
      	};
      	if (bid.hotel.state == null){
        	location = `${bid.hotel.city}, ${bid.hotel.country}`;
      	};
      	if (bid.hotel.city == null && bid.hotel.state == null){
        	location = `${bid.hotel.country}`;
      	};
      	if (bid.hotel.city == null && bid.hotel.state == null && bid.hotel.country == null){
        	location = '';
      	};
      	if (bid.hotel.city != null && bid.hotel.state != null && bid.hotel.country != null){
        	if (bid.hotel.city === bid.hotel.state){
          		location = `${bid.hotel.city}, ${bid.hotel.country}`;
        	} else{
          		if (bid.hotel.state === bid.hotel.country){
            		location = `${bid.hotel.city}, ${bid.hotel.country}`;
          		}else{
            		location = `${bid.hotel.city}, ${bid.hotel.state}, ${bid.hotel.country}`;
          		}
         	}
      	};
      	const bids = [];
    	this.props.bids.forEach(bidData => {
      		if(!(bidData.id==bid.id)){
      			if(bidData.eventId === this.props.bid.bidset.event.id){
        			bids.push(bidData)
     	 		}
     	 	}
    	});

    return(
       <div>
    	<div className="row">
    	   <div className="col-md-12"> 
          	   <Modal bsSize="large" show={this.props.showPopUp} onHide={()=>this.props.OnClose()}>
            	   <Modal.Header closeButton>
                      <Modal.Title>Accept/Decline Bids -{location} </Modal.Title>
                   </Modal.Header>
                   <Modal.Body>
                    <center>
                    	<Button bsStyle="danger" onClick={this.openConfirm} ><i className="fa fa-times fa-lg" />Decline all other bids</Button>&nbsp;&nbsp;
                      <Button bsStyle="info" onClick={()=>this.props.OnClose()} >Keep remaining bids open</Button>
                    </center><br/>
                    <BootstrapTable
                    	containerStyle = {{ marginTop: '10px' }}
                        data = {bids}
                        trStyle = { this.trStyle }
                        options = { options }
                        striped
                    >
                    	<TableHeaderColumn dataField="name" dataSort={ true } isKey={true} width="94" headerAlign="center" dataAlign="center"  dataFormat={this.formatHotelDisplay}>Hotel</TableHeaderColumn>
                    	<TableHeaderColumn dataField="group" dataSort={ true } width="80" headerAlign="center" dataAlign="center"  >Group</TableHeaderColumn>
                        <TableHeaderColumn dataField="location" dataSort={ true } width="90" headerAlign="center" dataAlign="center"  >Location</TableHeaderColumn>
                        <TableHeaderColumn dataField="state" dataSort={ true } width="110" headerAlign="center" dataAlign="center" dataFormat={this.formatStatusDisplay}>Status</TableHeaderColumn>
                        <TableHeaderColumn dataField="id"  width="150" headerAlign="center" dataAlign="center" dataFormat={this.btncolumn}></TableHeaderColumn>
                    </BootstrapTable>
                    <br/>
                   </Modal.Body>
                   <Modal.Footer >
                      <p></p>
                   </Modal.Footer>
                </Modal>
            </div>
        </div>
        <div className="row">
        	<div className="col-md-10">
        		<Modal bsSize="large" show={this.state.noteModel} onHide={()=>this.closeNote()}>
            	   <Modal.Header closeButton>
                      <Modal.Title>Add Note</Modal.Title>
                   </Modal.Header>
                   <Modal.Body>
                   	 <h1>Add Note</h1><br/>
                   	 <NoteFormRich onSubmit={this.saveNote} handleClose={this.closeNote} />
                   </Modal.Body>
                   <Modal.Footer >
                      <p></p>
                   </Modal.Footer>
                </Modal>
        	</div>
        </div>
        <div className="row">
          <div className="col-md-10">
            <Modal bsSize="large" show={this.state.showConfirm} onHide={()=>this.closeConfirm()}>
                 <Modal.Header closeButton>
                      <Modal.Title>All Bid Decline</Modal.Title>
                   </Modal.Header>
                   <Modal.Body>
                    <p>Are you sure want to decline all Bids?</p>
                    <ButtonToolbar style={{ float: 'right' }}>
                      <Button
                        bsStyle="success"
                        data-item="DE" 
                        onClick={this.DeclineAllBids}
                      >
                        Confirm
                      </Button>
                      <Button
                        bsStyle="success"
                        onClick={this.closeConfirm}
                      >
                      Cancel
                      </Button>
                    </ButtonToolbar><br/>
                   </Modal.Body>
                   <Modal.Footer >
                      <p></p>
                   </Modal.Footer>
                </Modal>
          </div>
        </div>
       </div> 
    );
  };
};

export default AcceptBidPopUp;


// WEBPACK FOOTER //
// src/routes/tours/components/AcceptBidPopUp.js